const body = document.body;
const slideInContainer = document.querySelectorAll(".slide-in-container");
const closeSlideInContainer = document.querySelectorAll(".js-close-slide-in-container");
const triggerSlideInContainer = document.querySelectorAll(".js-trigger-slide-in-container");

const closeContainer = () => {
  if (!slideInContainer.length) {
    return
  }
  
  [].forEach.call(slideInContainer, container => {
    container.classList.remove("active");
  });
  
  body.classList.remove("slide-active");
}

if (slideInContainer && closeSlideInContainer && triggerSlideInContainer.length) {
  [].forEach.call(triggerSlideInContainer, item => {
    item.addEventListener("click", e => {
      const id = item.dataset.id;
      if (!document.getElementById(id)) {
        return
      }
      e.preventDefault();
      body.classList.add("slide-active")
      document.getElementById(id).classList.add("active")
    })
  });
  
  [].forEach.call(closeSlideInContainer, closeButton => {
    closeButton.addEventListener("click", () => {
      closeContainer();
    })
  });
}

document.addEventListener("keydown", event => {
  if (event.key === "Escape") {
    closeContainer();
  }
})